import Actions from './pinned-container-actions';
import Api from './pinned-container-api';
import reducer from './pinned-container-reducer';
import sagas from './pinned-container-sagas';
import Selectors from './pinned-container-selectors';

export default {
  Actions,
  Api,
  name:       'pinnedContainer',
  namespace:  'pinnedContainer',
  pluralName: 'pinnedContainers',
  reducer,
  sagas:      [sagas],
  Selectors,
};
